export const ROLES = {
    PT: 'Physical Therapist',
    PTA: "Physical Therapy Assistant",
    Manager: 'Manager',
    Admin: 'Admin',
    Clerical: 'Clerical'
}